import React, {Component} from 'react';
import PropTypes from 'prop-types';
import StarRatingBase from './StarRatingBase';
import classNames from 'classnames';
import './StarRatingInput.less';

const RATINGS = [1, 2, 3, 4, 5];

class StarRatingInput extends Component {
    static propTypes = {
        /** Raw Rating Number (0 - 5). */
        rating: PropTypes.number,
        /** The StarRatingInput size variation, one of: '16'|'24'|'32' */
        size: PropTypes.oneOf(['16', '24', '32']),
        /** id attribute for the RadioGroup buried within radio. Required for a11y. */
        id: PropTypes.string.isRequired,
        /** The Input's label, required for a11y */
        label: PropTypes.node.isRequired,
        /** Called when the checked property changes */
        onChange: PropTypes.func,
        /** Error message to display, presence will affect display */
        errorMsg: PropTypes.node
    };

    constructor(props) {
        super(props);

        this.state = {
            hoverRating: 0
        };
    }

    get isTouchDevice() {
        if (typeof document !== 'undefined') {
            return 'ontouchstart' in document.documentElement;
        }
        return false;
    }

    handleChange = (event) => {
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    handleMouseEnter = (event) => {
        if (!this.isTouchDevice) {
            this.setState({hoverRating: Number(event.target.value)});
        }
    }

    handleMouseLeave = () => {
        if (!this.isTouchDevice) {
            this.setState({hoverRating: 0});
        }
    }

    render() {
        const {id, label, rating, size, errorMsg, ...rest} = this.props; // eslint-disable-line no-unused-vars
        const {hoverRating} = this.state;
        const whichRating = (hoverRating) ? hoverRating : rating;
        const starRatingInputClasses = classNames('StarRatingInput', 'text-muted', {
            'StarRatingInput--hover': !!hoverRating
        });

        return (
            <div role="radiogroup" aria-labelledby={id} aria-label={label}>
                <label htmlFor={id}>{label}</label>
                <StarRatingBase className={starRatingInputClasses} useStroke rating={whichRating} size={size} {...rest}>
                    <div className="StarRating__radiogroup">
                        {
                            RATINGS.map((score) => {
                                return (
                                    <span key={`${id}-${score}`} className={`StarRating--${size}px StarRatingInput__radio-wrapper`}>
                                        <input
                                            type="radio"
                                            className={`StarRating--${size}px StarRatingInput__radio`}
                                            id={`${id}-${score}`}
                                            name={`${id}-radio-group`}
                                            checked={(rating === Number(score))}
                                            label={score}
                                            onChange={this.handleChange}
                                            onMouseEnter={this.handleMouseEnter}
                                            onMouseLeave={this.handleMouseLeave}
                                            value={score}
                                        />
                                        <span className="StarRatingInput__radio-toggle"/>
                                    </span>
                                );
                            })
                        }
                    </div>
                </StarRatingBase>
                {errorMsg &&
                    <div className="has-error">
                        <div className="help-block">{errorMsg}</div>
                    </div>
                }
            </div>
        );
    }
}

export default StarRatingInput;
